import * as utils from '../functions/utils';
import TYPE from '../constants/newFeed';
import communityLikeUser from './communityUser';
import { APPROVAL_STATUS, STORY_STATUS } from '../constants/constants';
import { ICategory, IContentItem, IStory } from '../interfaces/ICommunity';
import Owner from './owner';
import { ICategoryData } from 'redhotpie-shared-lib/interfaces/INewFeed';

interface StoryObject {
  StoryID: number;
  Title: string;
  Summary: string;
  CategoriesValues: ICategoryData[];
  DateCreated: number;
  CommentCount: number;
  IsLiked: boolean;
  LikeCount: number;
  Author: any;
  ApprovalStatus: string;
  Status: string;
}

export default class Story {
  typeName: string;
  contentItem: IContentItem;

  constructor() {
    this.typeName = TYPE.OTG_NAME.OTG_Story;
    this.contentItem = {
      id: -1,
      title: '',
      description: '',
      categories: [],
      dateCreated: '',
      replyCount: 0,
      likeCount: 0,
      isMemberLike: false,
      owner: {},
      isPending: false,
      isDraft: false,
      approvalStatus: APPROVAL_STATUS.PENDING,
      status: '',
    };
  }

  static mappingCategory(obj: ICategoryData): ICategory {
    const _obj: ICategory = {
      id: obj.ItemID,
      text: obj.ItemName || obj.Text,
      listID: obj.ListID || [],
      value: obj.Value,
      isMatch: obj.IsMatch,
    };
    return _obj;
  }

  static mappingCategories(data: ICategoryData[]): ICategory[] {
    return data.map(item => this.mappingCategory(item));
  }

  static mappingObject(_obj: StoryObject): IStory {
    const obj = new Story();
    obj.contentItem.id = _obj.StoryID;
    obj.contentItem.title = _obj.Title ? _obj.Title : '';
    obj.contentItem.description = _obj.Summary ? _obj.Summary : '';
    obj.contentItem.categories = _obj.CategoriesValues ? this.mappingCategories(_obj.CategoriesValues) : [];
    obj.contentItem.dateCreated = _obj.DateCreated ? _obj.DateCreated : '';
    obj.contentItem.replyCount = _obj.CommentCount ? _obj.CommentCount : 0;
    obj.contentItem.isMemberLike = _obj.IsLiked;
    obj.contentItem.likeCount = _obj.LikeCount ? _obj.LikeCount : 0;
    obj.contentItem.owner = _obj.Author ? Owner.mappingObject(_obj.Author) : {};
    obj.contentItem.approvalStatus = _obj.ApprovalStatus ? _obj.ApprovalStatus : APPROVAL_STATUS.PENDING;
    obj.contentItem.status = _obj.Status ? _obj.Status : '';
    obj.contentItem.isDraft = _obj.Status === STORY_STATUS.Draft;
    return obj;
  }

  static mappingObjects(_data: any[]): IStory[] {
    return _data.map(item => this.mappingObject(item));
  }
}
